/**
 * Side effects for the stock module: where to navigate, and what to say.
 *
 * Errors surface here rather than as a silent no-op. A failed Post is the
 * case that matters — the cloud refuses with a 409 naming the line that can
 * no longer be received, and the operator has to see which one.
 */
import { ModuleEvents } from "./Actions";
import { router } from "../../App";
import { Actions } from "../../internals/app/Actions";

const failed = (payload) => !payload || payload.error;

/** Alert box wiring, matching what the other modules do. */
const flash = (dispatch, kind, ok) => {
  dispatch(Actions.common.openAlertBox(kind, true, ok ? "SUCCESS" : "ERROR"));
  setTimeout(
    () => dispatch(Actions.common.openAlertBox(kind, false, ok ? "SUCCESS" : "ERROR")),
    3000,
  );
};

const StockHandlers = {
  [ModuleEvents.CREATE_INTAKE]: ({ dispatch, payload }) => {
    if (failed(payload)) return flash(dispatch, "CREATE", false);
    // Straight into the editor for the document just created.
    return router.navigate(`/stock/intake/${payload.intake.intakeId}`);
  },

  [ModuleEvents.UPDATE_INTAKE]: ({ dispatch, payload }) => {
    flash(dispatch, "UPDATE", !failed(payload));
  },

  [ModuleEvents.DELETE_INTAKE]: ({ dispatch, payload }) => {
    if (failed(payload)) return flash(dispatch, "DELETE", false);
    flash(dispatch, "DELETE", true);
    return router.navigate("/stock");
  },

  [ModuleEvents.POST_INTAKE]: ({ dispatch, payload }) => {
    flash(dispatch, "UPDATE", !failed(payload));
  },

  [ModuleEvents.VOID_INTAKE]: ({ dispatch, payload }) => {
    flash(dispatch, "UPDATE", !failed(payload));
  },

  [ModuleEvents.CREATE_SUPPLIER]: ({ dispatch, payload }) => {
    flash(dispatch, "CREATE", !failed(payload));
  },

  [ModuleEvents.UPDATE_SUPPLIER]: ({ dispatch, payload }) => {
    flash(dispatch, "UPDATE", !failed(payload));
  },

  [ModuleEvents.CREATE_INGREDIENT]: ({ dispatch, payload }) => {
    flash(dispatch, "CREATE", !failed(payload));
  },

  [ModuleEvents.UPDATE_INGREDIENT]: ({ dispatch, payload }) => {
    flash(dispatch, "UPDATE", !failed(payload));
  },
};

export default StockHandlers;
